import { LoadsProps } from '@/common/models/ILoads';
import { cn } from '@/lib/utils';
import { LoadsPopover } from './popover';

const VISIBLE_CHIPS_LIMIT = 4;

export const Loads = ({
  items,
  selectedChips,
  onToggle,
  onSelectAll,
  viewBtnClassName,
}: LoadsProps) => {
  const visibleItems = items.slice(0, VISIBLE_CHIPS_LIMIT);
  const hasMore = items.length > VISIBLE_CHIPS_LIMIT;

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {visibleItems.map((item) => (
        <div
          key={item.id}
          onClick={() => onToggle(item)}
          className={cn(
            'px-4 py-1.5 rounded-full text-sm font-medium border-2 cursor-pointer transition-all',
            selectedChips.some((el) => el.id === item.id)
              ? 'bg-[#EBF6EE] border-[#D1EAD8] text-black'
              : 'bg-white border-gray-100 text-gray-400',
          )}
        >
          {item.number}
        </div>
      ))}

      {hasMore && (
        <LoadsPopover
          items={items}
          selectedChips={selectedChips}
          onToggle={onToggle}
          onSelectAll={onSelectAll}
          viewBtnClassName={viewBtnClassName}
        />
      )}
    </div>
  );
};
